<template>
  <div class="a">
    <Nav/>
    <PageBannerBig :banner="banner"></PageBannerBig>
    <div class="service-content">
      <div class="content">
        <div class="title-name">运营商大数据解决方案</div>
        <div class="title-sub">概述</div>
        <div class="text">
          电信运营商作为固定电话、移动电话和互联网接入的通信服务机构，是天生的大数据企业，拥有超海量的数据规模（Volume），真实、实时、稳定的数据流（Velocity），复杂多样的数据类型（Variety）和巨大的数据价值（Value）。作为整个互联网行业的数据管道，运营商多年积累的数据广度和深度，是其它企业、移动互联网企业难以企及的。受行业发展驱动以及竞争的影响，各大运营商迫切寻求新的利润增长点、提高运营效率、降低运营成本、提升服务水平，在此背景下充分利用好运营商自身的大数据优势是最佳路径之一。<br>
          橡诺科技运营商大数据平台基于电信运营商大数据资源的丰富性、完整性和连续性特征构建，在充分了解运营商行业资源与市场需求情况下，采用最先进的大数据技术，打造开放的SaaS化大数据平台，充分挖掘数据价值，助力运营商运营决策人员洞察商机、开拓业务、高效运营。
        </div>
        <div class="title-sub">解决方案</div>
        <div class="text">
          橡诺科技运营商大数据平台采用自主研发的ETL配套工具，通过对多源异构数据的采集、整合、处理，运用大数据文本分析技术和累积的行业挖掘模型，深入挖掘客户特征、需求，构建全面的用户画像体系。用户可根据业务需求定制所需业务，为运营、服务、决策提供数据支撑。<br>
          整体方案
          <div class="img"><img src="@/assets/img/solution/8/1.png"></div>
          平台服务内容<br>
          <div class="img"><img src="@/assets/img/solution/8/2.png"></div>
          对内业务提升、运营优化<br>
          以消费者为中心，开展用户行为模式的分析与数据挖掘，支撑各类数据应用，包括基础设施建设和网络运营管理优化，挖掘新业务并实现精准营销，客户服务优化、企业运营决策支持等。<br>
          对外提供数据服务<br>
          运营商整合数据，通过数据挖掘脱敏生成结果数据集，提供给企业客户，帮助企业了解用户，提高竞争力，包括精准广告、数据报告、精准营销、能力开放和能力租用等。
        </div>
        <div class="title-sub">方案优势</div>
        <div class="text">
          安全保障<br>
          从规划、管理、操作、数据层面构建四位一体化的数据安全管理体系。遵循网络安全与物理安全并重的原则，敏感数据脱敏处理，保证数据安全和避免数据泄露。<br>
          简约智能实用<br>
          通过构建360度多级标签体系，刻画群体与个人用户画像，辅以贴合业务需求的功能，以清晰明了的可视化手段展示，并对业务结果进行智能反馈。
        </div>
        <div class="title-sub">客户收益</div>
        <div class="text">
          增加收益<br>
          通过大数据分析，为传统通信、带宽业务提供支撑，实现业绩的显著提升<br>
          新业务拓展<br>
          通过对人群细分，成功挖掘用户个性化需求，挖掘具有价值的潜在用户需求，发展创新业务<br>
          提升客户满意度<br>
          增加客户满意度、粘度，有效防止用户流失<br>
          战略决策支撑<br>
          为运营商业务，特别是基础设施建设、硬件资源布局、业务拓展等提供战略决策层数据支撑，协助运营商决策人员把控业务航向
        </div>
        <div class="title-sub">典型客户</div>
        <div class="text">
          电信运营商、互联网企业
        </div>
      </div>
      <Mission/>
    </div>

    <Contact/>
    <Footer/>
  </div>
</template>

<script>
import Nav from '@/components/Nav'
import PageBannerBig from '@/components/PageBannerBig'
import Contact from '@/components/Contact'
import Footer from '@/components/Footer'
export default {
  name: '',
  components: {
    Nav,
    PageBannerBig,
    Contact,
    Footer
  },
  data () {
    return {
      banner: {
        img: require("@/assets/img/solution-banner.jpg"),
        title: "为您提供专业的解决方案",
        sub: "专业的服务 高效的方案"
      }
    }
  }
}
</script>

<style scoped lang="less">
.service-content{
    width: 100%;
    padding-bottom: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    background-image: url(../../assets/img/service-bg.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    .content{
      width: 1200px;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      .title-name{
        height: 38px;
        color: #333333;
        transform: .5s;
        line-height: 38px;
        font-size: 30px;
        margin-top: 80px;
        margin-bottom: 38px;
        text-align: center;
        box-sizing: border-box;
      }
      .title-sub{
        color: #333;
        line-height: 24px;
        font-size: 20px;
        text-align: left;
        box-sizing: border-box;
        width: 200px;
        margin-top: 30px;
        margin-bottom: 10px;
        border-radius: 30px;
      }
      .text{
        color: #666;
        line-height: 24px;
        font-size: 14px;
        box-sizing: border-box;
        .img{
          padding: 30px;
          margin: 20px auto;
          background: #fff;
          text-align: center;
        }
      }
    }
}
</style>